import { __makeTemplateObject } from 'tslib';
import { css } from 'styled-components';
import { font } from '../../theme/reset/index.js';
import { buildSpacingCSS } from '../../theme/utils/spacing.js';

var LinkListStyles = function LinkListStyles(theme, globalMargins, propMargins) {
  return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n  ", "\n  &.fi-link-list {\n    padding: 0;\n    margin: 5px 0 0 0;\n  }\n  &.fi-link-list--small {\n    & .fi-link-list-item_icon .fi-icon {\n      transform: translateY(0.15em);\n    }\n    & .fi-link {\n      ", "\n    }\n  }\n"], ["\n  ", "\n  ", "\n  &.fi-link-list {\n    padding: 0;\n    margin: 5px 0 0 0;\n  }\n  &.fi-link-list--small {\n    & .fi-link-list-item_icon .fi-icon {\n      transform: translateY(0.15em);\n    }\n    & .fi-link {\n      ", "\n    }\n  }\n"])), buildSpacingCSS(globalMargins), buildSpacingCSS(propMargins, true), font(theme)('bodyTextSmall'));
};
var templateObject_1;

export { LinkListStyles };
//# sourceMappingURL=LinkList.baseStyles.js.map
